import { render, staticRenderFns } from "./PedidoAbaListagem.vue?vue&type=template&id=6945f215&scoped=true"
import script from "./PedidoAbaListagem.vue?vue&type=script&lang=js"
export * from "./PedidoAbaListagem.vue?vue&type=script&lang=js"
import style0 from "./PedidoAbaListagem.vue?vue&type=style&index=0&id=6945f215&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6945f215",
  null
  
)

export default component.exports